<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="550px">
        <v-card>
            <v-card-title class="pa-0">
                <v-col class="text-end pa-0" cols="12">
                    <v-btn class="pa-0" icon dark @click="closeForm()">
                        <v-icon color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-col>
                <v-col class="text-center pt-0" cols="12">
                    <h1 style="font-size: 24px" class="mb-2 mt-0">
                        Protocolo único
                        {{ critica_ignorada }}
                    </h1>
                    <p style="font-size: 14px; line-height: 10px" class="mb-2">
                        Deseja aplicar este protocolo e/ou data de envio a todos os lotes?
                    </p>
                </v-col>
                <v-row  wrap class="px-2 my-0 mx-2">
                <v-col class="text-left pb-2 pt-0" cols="5">
                    <span class="card-title-form-guia textsRec" style="display: block">Prestador</span>
                    <span class="card-title-form-guia" style="font-weight:normal; display: block">{{info.prest_nome }}</span>
                </v-col>
                <v-col class="text-left pb-2 pt-0" cols="4">
                    <span class="card-title-form-guia textsRec" style="display: block">Operadora</span>
                    <span class="card-title-form-guia" style="font-weight:normal">{{info.oper_nome}}</span>
                </v-col>
                <v-col class="text-left pb-2 pt-0" cols="3">
                    <span class="card-title-form-guia textsRec" style="display: block">Valor. calc (R$)</span>
                    <span class="card-title-form-guia" style="font-weight:normal; color: green"><b>{{ info.arq_vl_calculado | formatPrice }}</b></span>
                </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="px-1 py-0">
                <v-form ref="protocoloEmMassaForm" :value="formValid">
                <v-row  wrap class="px-0 ma-0">
                    <v-col class="py-0 pb-0 px-6" cols="12" v-if="exibeIgnoraCritica">
                    <v-switch
                        x-small
                        v-model="critica_ignorada"
                        :label="'Ignorar crítica automaticamente'"
                        color="primary"
                        class="mr-0"
                        @change="updateCriticaIgnorada(critica_ignorada)"
                        ></v-switch>
                    </v-col>
                    <v-col class="py-0 pb-5 px-6" cols="6">
                        <label>Número</label>
                        <v-text-field
                        v-model="formData.env_op_protocolo"
                        placeholder="Protocolo"
                        type="number"
                        single-line
                        outlined
                        dense
                        hide-details
                        :rules="[formRules.requiredField, formRules.max20]"
                        ></v-text-field>
                    </v-col>
                    <v-col class="py-0 px-6" cols="6">
                        <label>Data</label>
                        <v-menu
                        ref="dtI"
                        v-model="dtI"
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="dateFormatted"
                            dense
                            v-mask="'##/##/####'"
                            format="DD/MM/YYYY"
                            placeholder="DD/MM/YYYY"
                            label
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            append-icon="mdi-calendar-blank"
                            @blur="date = parseDate(dateFormatted); formData.env_op_dt_protocolo = date"
                            :rules="[formRules.requiredField, formRules.typeDateFormated]"
                            ></v-text-field>
                        </template>
                        <v-date-picker color="primary" 
                            v-model="date"
                            @input="dateFormatted = formatDate(date); formData.env_op_dt_protocolo = date"
                            no-title
                            scrollable
                        ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col class="py-0 px-6" cols="12">
                        <label>Retorno de operadora</label>
                        <v-select
                        v-model="formData.env_op_status_protocolo"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        :items="status"
                        item-text="descricao"
                        item-value="id"
                        placeholder="Selecione"
                        outlined
                        :disabled="isLoteComplementar"
                        :rules="formRules.required"
                        ></v-select>
                    </v-col>
                    <v-col v-if="formData.env_op_status_protocolo == '1' || formData.env_op_status_protocolo == '4'" class="py-0 px-6" cols="12">
                        <label>Crítica</label>
                        <v-textarea 
                        outlined
                        flat
                        solo
                        dense
                        height="80px"
                        :rules="formRules.required"
                        placeholder="Erro acusado pela operadora"
                        v-model="formData.erro_protocolo"
                        ></v-textarea>
                    </v-col>
                </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="pt-0 pb-3 px-6">
                <v-btn
                    height="30px"
                    small
                    color="primary"
                    depressed
                    outlined
                    @click="closeForm()"
                >
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" height="30px" small depressed @click="saveForm()">
                    Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        close: Function,
        dialog: Boolean,
        exibeIgnoraCritica: { type: Boolean, default: false },
        formatDate: Function,
        formData: Object,
        formRules: Object,
        info: Object,
        parseDate: Function,
        save: Function,
        status: Array,
        updateCriticaIgnorada: Function
    },
    data() {
        return {
            critica_ignorada: false,
            dtI: false,
            date: null,
            dateFormatted: null,
            formValid: true,
            isLoteComplementar: false
        }
    },
    methods: {
        closeForm() {
            this.$refs.protocoloEmMassaForm.reset()
            this.$refs.protocoloEmMassaForm.resetValidation()
            this.close()
        },
        saveForm() {
            if (this.$refs.protocoloEmMassaForm.validate()) {
                this.save()
            }
        }
    }
}
</script>

<style>

</style>